module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Login Information")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [(_vm.LoginErrorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginErrorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "AccountEmailAddress"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.EmailAddress),
      expression: "LoginFormInputs.EmailAddress"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("New Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.emailAddress),
      expression: "LoginEdit.emailAddress"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountEmailAddress
    },
    attrs: {
      "type": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.LoginEdit.emailAddress)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "emailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountEmailAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.EmailAddressConfirm),
      expression: "LoginFormInputs.EmailAddressConfirm"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Confirm Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.emailAddressConfirm),
      expression: "LoginEdit.emailAddressConfirm"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountEmailAddressConfirm
    },
    attrs: {
      "type": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.LoginEdit.emailAddressConfirm)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateConfirmEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "emailAddressConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountEmailAddressConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountEmailAddressConfirm))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.NewPassword),
      expression: "LoginFormInputs.NewPassword"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.newPassword),
      expression: "LoginEdit.newPassword"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountPassword, error_field2: _vm.hasPasswordError
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.LoginEdit.newPassword)
    },
    on: {
      "keyup": function($event) {
        return _vm.CheckPasswordDigits();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "newPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountPassword))]) : (_vm.hasPasswordError && !_vm.LoginValidationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasPasswordErrorMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.NewPasswordConfirm),
      expression: "LoginFormInputs.NewPasswordConfirm"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Confirm New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.newPasswordConfirm),
      expression: "LoginEdit.newPasswordConfirm"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountPasswordConfirm, error_field2: _vm.hasConfirmPasswordError
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.LoginEdit.newPasswordConfirm)
    },
    on: {
      "keyup": function($event) {
        return _vm.CheckConfirmPasswordDigits();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "newPasswordConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountPasswordConfirm))]) : _vm._e(), _vm._v(" "), (_vm.hasConfirmPasswordError && !_vm.LoginValidationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasConfirmPasswordErrorMessage))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "background-color": "whitesmoke",
      "padding-top": "15px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.Password),
      expression: "LoginFormInputs.Password"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.password),
      expression: "LoginEdit.password"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.OldAccountPassword
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.LoginEdit.password)
    },
    on: {
      "keyup": function($event) {
        return _vm.CheckMatchCurrentPassword()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.OldAccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.OldAccountPassword))]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v("Email Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v("Password:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v("Current Password*\n                    "), _c('span', {
    attrs: {
      "data-balloon": "To change your email or password enter your existing password in the Current Password field.",
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cc670cf4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc670cf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/userAccount/accountEdit/EditLoginInfo.vue
// module id = 554
// module chunks = 3